import { useContext } from "react";
import { ReduxFormContext } from "redux-form/es/ReduxFormContext";

export const useReduxForm = () => {
    return useContext(ReduxFormContext);
};
